module.exports = __webpack_public_path__ + "img/13.4fb50a4a.webp";